import { ApiImageClient } from "@/api";

async function apiUserGetWarehouse({ id }: { id: string }) {
  try {
    const result = await ApiImageClient.get(
      `/warehouses/${id}?populate=*`,
    ).then(({ data }) => data);
    return result;
  } catch (e) {
    console.error("apiUserGetWarehouse_Error", e);
    return e;
  }
}

async function apiUserGetWarehouses() {
  try {
    const result = await ApiImageClient.get(`/warehouses?populate=*`).then(
      ({ data }) => data,
    );
    return result;
  } catch (e) {
    console.error("apiUserGetWarehouses_Error", e);
    return e;
  }
}

async function apiUserPostWarehouse({ data }: { props: any }) {
  try {
    const result = await ApiImageClient.post("/warehouses", { data }).then(
      ({ data }) => data,
    );
    return result;
  } catch (e) {
    console.error("apiUserPostWarehouse_Error", e);
    return e;
  }
}

async function apiUserPutWarehouses({ id, data }) {
  try {
    const result = await ApiImageClient.put(`/warehouses/${id}`, { data }).then(
      ({ data }) => data,
    );
    return result;
  } catch (e) {
    console.error("apiUserPutWarehouses_Error", e);
    return e;
  }
}

export {
  apiUserGetWarehouse,
  apiUserPutWarehouses,
  apiUserGetWarehouses,
  apiUserPostWarehouse,
};
